import type { QueryClient } from "@tanstack/react-query";
import { odooClient } from "../services/odooClient";

export const APP_DATA_REFRESH_EVENT = "app-data-refresh";

/** Safe localStorage keys to drop (never auth / session / user prefs). */
const SAFE_CACHE_STORAGE_KEYS = ["artists_page_cache_v1"] as const;

function clearSafeLocalStorageCaches() {
  for (const key of SAFE_CACHE_STORAGE_KEYS) {
    try {
      localStorage.removeItem(key);
    } catch {
      // ignore
    }
  }
}

/**
 * Clears in-app data caches and reloads the page so lists/dashboard refetch from Odoo.
 * Does not clear login cookies or auth storage.
 */
export async function refreshAppData(queryClient: QueryClient): Promise<void> {
  odooClient.clearClientCaches();
  clearSafeLocalStorageCaches();

  queryClient.clear();
  try {
    await queryClient.invalidateQueries();
    await queryClient.refetchQueries({ type: "active" });
  } catch {
    // non-fatal if no react-query consumers on this page
  }

  window.dispatchEvent(new CustomEvent(APP_DATA_REFRESH_EVENT));

  // Full reload so pages that fetch outside React Query also get fresh data.
  window.location.reload();
}
